import { render, staticRenderFns } from "./lifeDetail.vue?vue&type=template&id=6526d517&scoped=true&"
import script from "./lifeDetail.vue?vue&type=script&lang=js&"
export * from "./lifeDetail.vue?vue&type=script&lang=js&"
import style0 from "./lifeDetail.vue?vue&type=style&index=0&id=6526d517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526d517",
  null
  
)

export default component.exports